/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const HistoryJumpIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <polyline points="21.849 18.944 15.31 20.391 15.751 13.709" />
      <path d="M15.324,20.327 C20.806,15.676 21.675,7.453 17.025,1.971" />
      <polyline points="9.5 22.5 10.5 22.5 10.5 21.5" />
      <polyline points="5.5 22.5 4.5 22.5 4.5 21.5" />
      <polyline points="5.5 16.5 4.5 16.5 4.5 17.5" />
      <polyline points="9.5 16.5 10.5 16.5 10.5 17.5" />
      <polyline points="9.5 14.5 10.5 14.5 10.5 13.5" />
      <polyline points="5.5 14.5 4.5 14.5 4.5 13.5" />
      <polyline points="5.5 8.5 4.5 8.5 4.5 9.5" />
      <polyline points="9.5 8.5 10.5 8.5 10.5 9.5" />
      <rect x="4.5" y="0.5" width="6" height="6" />
    </g>
  </svg>
);

export default HistoryJumpIcon;
